//通用方法

import Vue from 'vue'
import moment from 'moment'
//将数组元素拼接成字符串
Vue.prototype.arrToString = function (arr) {
    let str = ''
    if (arr && arr.length > 0) {
        arr.forEach(e => {
            str += e + ',';
        });
    }
    return str.substr(0, str.length - 1)//去除最后一个逗号
}

//处理行内样式背景图 不支持空格
Vue.prototype.trSpace = function (imageUrl) {
    return new Promise(function (resolve, reject) {
        if (imageUrl) {
            let image = new Image();
            //解决跨域问题
            image.setAttribute('crossOrigin', 'anonymous');
            image.src = imageUrl

            let that = this;
            //image.onload为异步加载
            image.onload = () => {
                var canvas = document.createElement("canvas");
                canvas.width = image.width;
                canvas.height = image.height;
                var context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, image.width, image.height);
                //这里的dataurl就是base64类型
                var dataURL = canvas.toDataURL("image/jpeg", 1);//使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
                resolve(dataURL)
            }
        }
    })
}
//兼容老数据 v-html渲染
Vue.prototype.hexToDec = function (str) {
    if (str) {
        str = str.replace(/\\/g, "%");
        return unescape(str);
    }
    return ''

}
//引用对象  浅复制
Vue.prototype.copy = function (obj) {
    var newobj = {};
    for (var attr in obj) {
        newobj[attr] = obj[attr];
    }
    return newobj;
}

//删除对象中的空串和空数组
Vue.prototype.deps = function (obj) {
    let object = Vue.prototype.copy(obj);
    for (var i in object) {
        var value = object[i];
        // sodino.com
        // console.log('typeof object[' + i + ']', (typeof value));
        if (typeof value === 'object') {
            if (Array.isArray(value)) {
                if (value.length == 0) {
                    delete object[i];
                    //console.log('delete Array', i);
                    continue;
                }
            }
            //this.deleteEmptyProperty(value);
            if (isEmpty(value)) {
                //console.log('isEmpty true', i, value);
                delete object[i];
                //console.log('delete a empty object');
            }
        } else {
            if (value === '' || value === null || value === undefined) {
                delete object[i];
                //console.log('delete ', i);
            } else {
                //console.log('check ', i, value);
            }
        }
    }
    return object
}

function isEmpty(object) {
    for (var name in object) {
        return false;
    }
    return true;
}

// 处理时间格式 
Vue.prototype.formatTime = function (time) {//tiem时间数组
    let newTime = [];
    if (time && time.length) {
        newTime[0] = moment(time[0]).format('YYYY-MM-DD');
        newTime[1] = moment(time[1]).format('YYYY-MM-DD');
    }
    return newTime
}
// 处理时间格式 
Vue.prototype.formatSingleTime = function (time) {
    let newTime = ''
    if (time) {
        newTime = moment(time).format('YYYY-MM-DD');
    }
    return newTime
}
// 处理时间格式 
Vue.prototype.formatDetailTime = function (time) {
    time ? time = moment(time).format('YYYY-MM-DD HH:mm:ss') : '';
    return time
}
// 转换成二维数组
Vue.prototype.twoBitArray = function (value) {
    if (value.length > 0) {
        var newArr = [];
        // 原一维数组按照每4个拆分
        for (var i = 0; i < value.length; i += 4) {
            newArr.push(value.slice(i, i + 4));
        }
        return newArr;
    } else {
        return []
    }

}
// 判断参数对象是否有空
Vue.prototype.paramsValidate = function (params) {
    let flag = true;
    for (var key in params) {
        if (params[key] != '0' && !params[key]) {
            flag = false;
            return false; // 终止程序
        }
    }

    return flag;
}
// html剔除富文本标签，留下纯文本 最后清楚&nbsp;
Vue.prototype.getSimpleText = function (html) {
    if (html) {
        var re1 = new RegExp("<.+?>", "g"); //匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
        var msg = html.replace(re1, "").replace(/&nbsp;|&ldquo;|&rdquo;/g, ""); //执行替换成空字符
        return msg;
    } else {
        return ""
    }

}
// 筛选富文本里面的图片
Vue.prototype.getImgList = function (str) {
    var list = [];
    str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g,
        function (
            match,
            capture
        ) {
            list.push(capture);
        });
    return list;
}
// 删除数组里面的空对象
Vue.prototype.delEmptyObj = function (arr) {
    if (arr.length > 0) {
        arr.forEach((ele, index) => {
            if (!Object.keys(ele).length) {
                arr.splice(index, 1)
            }
        })

    }
    return arr;
}

// 判断某个元素是否在可视区域

Vue.prototype.isElementNotInViewport = function (el) {
    if (!el) {
        return false
    }
    let rect = el.getBoundingClientRect();
    return (
        rect.top >= (window.innerHeight || document.documentElement.clientHeight) ||
        rect.bottom <= 0
    );
};


// 时间戳转换成天时分秒  拆分返回
Vue.prototype.transTime = function (val) {
    let second_time = val / 1000
    var time = "<span class='timeTag'>" + parseInt(second_time) + "</span>秒";
    if (parseInt(second_time) > 60) {

        var second = parseInt(second_time) % 60;
        var min = parseInt(second_time / 60);
        time = "<span class='timeTag'>" + min + "</span>分<span class='timeTag'>" + second + "</span>秒";

        if (min > 60) {
            min = parseInt(second_time / 60) % 60;
            var hour = parseInt(parseInt(second_time / 60) / 60);
            time = "<span class='timeTag'>" + hour + "</span>时<span class='timeTag'>" + min + "</span>分<span class='timeTag'>" + second + "</span>秒";

            if (hour > 24) {
                hour = parseInt(parseInt(second_time / 60) / 60) % 24;
                var day = parseInt(parseInt(parseInt(second_time / 60) / 60) / 24);
                time = "<span class='timeTag'>" + day + "</span>天<span class='timeTag'>" + hour + "</span>时<span class='timeTag'>" + min + "</span>分<span class='timeTag'>" + second + "</span>秒";
            }
        }


    }
    // 富文本
    return "请在" + time + "内确认";
    // return time;
}


// WEBPACK FOOTER //
// ./src/utils/core.js